module.exports = __webpack_public_path__ + "static/img/qrcode.ffd5491a.png";